import { useTranslation } from 'react-i18next';
import { ITableToggle } from '../../../../base';

export const useTableToggles = (): Array<ITableToggle> => {
    const { t } = useTranslation();

    return [
        {
            key: 'include_legacy',
            defaultValue: false,
            label: t('tablesBase.showLegacyJobs'),
        },
    ];
};
